import { TableColumn } from '../../model';
import { ReactNode } from 'react';

export type TableFoldersColumn<T1, T2> = TableColumn<T1> & {
  renderFolder?: (row: T2, rowNum: number) => ReactNode;
};
